export default __webpack_public_path__ + "static/media/404-wizard.9de11d0b.png";